import React from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import {ILabel} from 'modules/products/types';
import {MODALS} from 'modules/modals/constants';
import {Modal} from 'modules/modals/components/Modal';
import {showModal} from 'modules/modals/thunks';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import dynamic from 'next/dynamic';
import {ModalLazyLoader} from 'components/ModalLazyLoader';
import {ButtonNew} from 'components/ButtonNew';
import Picture from 'components/Picture';
import {useInView} from 'react-intersection-observer';
import {useGrowingDiscountGtag} from 'modules/product-card/analytics/gtag/hooks/useGrowingDiscountGtag';

const GrowingDiscountModal = dynamic(() => import('modules/product-card/components/GrowingDiscountModal'), {
    loading: () => <ModalLazyLoader />,
});

interface IProps extends ILabel {}

const ProductGrowingDiscountBanner: React.FC<IProps> = ({url, growingBannerPdpText, ...props}) => {
    const dispatch = useAppDispatch();

    const {handleModalShow, handleWidgetInView, handleWidgetClick, handleConditionsWidgetClick} =
        useGrowingDiscountGtag();

    const handleOpenModal = () => {
        handleConditionsWidgetClick();
        dispatch(showModal(MODALS.PRODUCT_GROWING_DISCOUNT_MODAL.name));
        handleModalShow();
    };

    const {ref} = useInView({
        triggerOnce: true,
        threshold: 1,
        onChange: (inView) => {
            if (inView) {
                handleWidgetInView(inView);
            }
        },
    });

    return (
        <>
            <div ref={ref} className={style.growingDiscountBanner}>
                <Typography className={style.growingDiscountTitle} variant={'label-16-m'}>
                    {growingBannerPdpText}
                </Typography>
                <div className={style.growingDiscountButtons}>
                    <ButtonNew href={url} target={'_blank'} variant={'small'} theme={'red'} onClick={handleWidgetClick}>
                        Все товары акции
                    </ButtonNew>
                    <ButtonNew
                        className={style.growingDiscountInfo}
                        onClick={handleOpenModal}
                        variant={'small'}
                        theme={'ghost'}
                    >
                        Условия акции
                    </ButtonNew>
                </div>
                <div className={style.growingDiscountBannerImageBlock}>
                    <Picture src={'/images/product-detailed/growing-discount.webp'} />
                </div>
            </div>
            <Modal name={MODALS.PRODUCT_GROWING_DISCOUNT_MODAL.name} willMount={true} hasPortal={true}>
                <GrowingDiscountModal url={url} {...props} />
            </Modal>
        </>
    );
};

export default ProductGrowingDiscountBanner;
